import { render, staticRenderFns } from "./ClusterJobSeekersPIP.vue?vue&type=template&id=90a169c2&scoped=true&"
import script from "./ClusterJobSeekersPIP.vue?vue&type=script&lang=js&"
export * from "./ClusterJobSeekersPIP.vue?vue&type=script&lang=js&"
import style0 from "./ClusterJobSeekersPIP.vue?vue&type=style&index=0&id=90a169c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a169c2",
  null
  
)

export default component.exports